import { render, staticRenderFns } from "./ActivityDetailsVehicle.vue?vue&type=template&id=467a9f2b&"
import script from "./ActivityDetailsVehicle.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports